import { useAuthBearerFetch } from "matsuri-hooks"
import { AssignStatus } from "@/domain/approvalRequest"
import { m2mCleaning_managerV4 } from "@/endpoints/m2m-cleaning.manager-v4"

type CleanerId = string
type OperationId = string

export interface ApprovalRequest {
    id: string
    status: AssignStatus
    cleanerId: string
    unitPrice: number
    createdAt: number
    specialBonus?: number
}

type ApprovalRequestsByOperationIdsOutput = Record<
    OperationId,
    Record<CleanerId, ApprovalRequest>
>

export const useApprovalRequestsByOperationIds = (
    token: string,
    operationIds: string[]
) => {
    const endpoint =
        m2mCleaning_managerV4.listLatestApprovalRequestPerUserByCleaningIds

    return useAuthBearerFetch<ApprovalRequestsByOperationIdsOutput>(
        token,
        operationIds.length ? endpoint() : null,
        {
            body: JSON.stringify({ cleaningIds: operationIds }),
            method: endpoint.method
        }
    )
}

export type CompanyApprovalRequestStatus =
    "Pending" | "Approved" | "Rejected" | "NotRequired"

interface CompanyApprovalRequest {
    id: string
    status: CompanyApprovalRequestStatus
    cleaningId: string
    companyId: string
    createdAt: number
    updatedAt: number | null
}

type CompanyApprovalRequestsByCleaningId = Record<
    string,
    CompanyApprovalRequest
>

export const useCompanyApprovalRequestsByCleaningId = (
    token: string,
    cleaningId: string | undefined
) => {
    return useAuthBearerFetch<CompanyApprovalRequestsByCleaningId>(
        token,
        cleaningId
            ? m2mCleaning_managerV4.listLatestCompanyApprovalRequestsByCleaningId(
                  { cleaningId }
              )
            : null,
        {
            method: m2mCleaning_managerV4
                .listLatestCompanyApprovalRequestsByCleaningId.method
        }
    )
}
